import Vue from "vue";
import Vuex from "vuex";

import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    onlineState: navigator.onLine,
    logoVisible: true,
    postsData: {
      post: [],
      page: [],
      attachment: []
    },
    authors: [],
    taxonomies: {},
    isOpenNav: true,
    userOpenNav: true,
    isFrontPage: false,
    frontPageLoaded: false,
    pageIsLoading: true,
    storeVersion: false,
    cacheKey: "tb_app_cache",
    loadedEverything: false,
    activeVideo: null,
    title: ""
  },
  getters,
  mutations,
  actions
});
